import SideMenu from '@/containers/side-menu/SideMenu.vue';
import ControlPanel from '@/pages/control-panel/ControlPanel.vue';

export default {
  path: '/control-panel',
  name: 'ControlPanel',
  components: {
    mainContent: ControlPanel,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'roles',
    },
    breadcrumb: {
      title: 'Configurações',
      paths: [{ title: 'Configurações' }],
    },
  },
};
